import type { StaticTextLookup } from 'src/translators/static-text-lookup';

export const staticTextLookup: Partial<StaticTextLookup> = { enterValidTaxId: "Please enter a valid tax ID (e.g. RSSMRA80A01H501U or 12345678901)"}
